
const Goals = () => (
  <div className="">
    <h1>Goals</h1>
    <p>Select the client’s goals.</p>
    <div className="goal-list">
      {['Build Muscle', 'Improve Endurance', 'Increase Strength', 'Increase Mobility'].map((goal, i) => (
        <div key={i} className={`goal-item goal-${i}`}>{goal}</div>
      ))}
    </div>
  </div>
);

export default Goals;
